import { getRandomId } from "../../utils/basics";

export default {
  process: {
		edit: false,
		loading: false,
		error: null,
		succeed: false
	},
	mediaType: null,
	category: null,
	epId: {
		loading: false,
		error: null,
		data: '',
	},
	title: {},
	description: {},
	tags: [],
	seoTitle: {},
	seoDescription: {},
	seoKeywords: {},
	eventDate: null,
	modifiedDate: null,
	startPublicationDate: null,
	endPublicationDate: null,
	startEmbargoDate: null,
	endEmbargoDate: null,
	termsOfUse: {},
	copyrightAuthor: {},
	copyrightYear: '',
	copyrightLicense: {},
	links:[
		{
			id: getRandomId() - 111, // random number to avoid conflicts
			ref: {},
			description: {}
		}
	],
	attachments: [
		{
			id: getRandomId(), // random number to avoid conflicts
			ref: {},
			description: {}
		}
	],
	files: [],
	subtitles: [],
	thumbnail: [],
	multilanguageFiles: {},
	owner: '',
	creationDate: null,
	transcript: {}
};